import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WalletDetails from "./walletDetails";
import PlanDetails from "./planDetails";
import HistorySection from "./HistorySection";
import { callApi } from "../../../api/fetch";
import { logout } from "../../../utils/logout";

const Billing = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const orgId = localStorage.getItem("organisation_id");
  if (!orgId) {
    localStorage.clear();
    logout({ redirectToLogin: true });
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const env = searchParams.get("env");

    // 

    if (!env || (env !== "production" && env !== "sandbox")) {
      searchParams.set("env", "production");
      navigate(`${location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    }
  }, [location.search, location.pathname, navigate]);

  const [planLoading, setPlanLoading] = useState<boolean>(true);
  const [planData, setPlanData] = useState<any>(null);
  const [planError, setPlanError] = useState<string | null>(null);

  const fetchPlanData = async () => {
    try {
      setPlanLoading(true);
      setPlanError(null);

      const response = await callApi(`/organisations/${orgId}/plan-info`, {
        method: "GET",
      });

      setPlanData(response);
    } catch (error: any) {
      setPlanError(error?.message || "Failed to fetch plan data");
      console.error("Plan API Error:", error);
    } finally {
      setPlanLoading(false);
    }
  };

  useEffect(() => {
    if (orgId) {
      fetchPlanData();
    }
  }, [orgId]);

  const orgPlanType = useMemo(() => {
    if (planData?.current?.plan?.plan_type) {
      return planData?.current?.plan?.plan_type;
    }

    return null;
  }, [planData]);

  return (
    <div>
      <WalletDetails orgPlanType={orgPlanType} />
      <PlanDetails loading={planLoading} planData={planData} error={planError} />
      <HistorySection planInfo={planData} />
    </div>
  );
};

export default Billing;
